<template>
    <div>
        <div class="page-breadcrumb">
            <div class="row">
                <div class="col-5 align-self-center">
                    <h4 class="page-title"><i class="fas fa-user-plus"></i> Partner Add Request</h4>
                    <div class="d-flex align-items-center">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <router-link :to="{name: 'dashboard'}">Home</router-link>
                                </li>
                                <li class="breadcrumb-item">Request
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header bg-info">
                        <h4 class="m-b-0 text-white">Request for partnership with {{partner.marketplace_name}}</h4>
                    </div>
                    <form class="form-horizontal">
                        <div class="form-body">
                            <div class="card-body">
                                <h4 class="card-title">Organization Info</h4>
                            </div>
                            <hr class="m-t-0 m-b-40">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group row">
                                            <label class="control-label text-right col-md-3">Name:</label>
                                            <div class="col-md-9">
                                                <p class="form-control-static"> {{partner.name}} </p>
                                            </div>
                                        </div>
                                    </div>
                                    <!--/span-->
                                    <div class="col-md-6">
                                        <div class="form-group row">
                                            <label class="control-label text-right col-md-3">Email:</label>
                                            <div class="col-md-9">
                                                <p class="form-control-static"> {{partner.email}} </p>
                                            </div>
                                        </div>
                                    </div>
                                    <!--/span-->
                                </div>
                                <!--/row-->
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group row">
                                            <label class="control-label text-right col-md-3">Web:</label>
                                            <div class="col-md-9">
                                                <p class="form-control-static"> {{partner.web}} </p>
                                            </div>
                                        </div>
                                    </div>
                                    <!--/span-->
                                    <div class="col-md-6">
                                        <div class="form-group row">
                                            <label class="control-label text-right col-md-3">Phone:</label>
                                            <div class="col-md-9">
                                                <p class="form-control-static"> {{partner.phone}} </p>
                                            </div>
                                        </div>
                                    </div>
                                    <!--/span-->
                                </div>
                                <!--/row-->
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group row">
                                            <label class="control-label text-right col-md-3">Description:</label>
                                            <div class="col-md-9">
                                                <p class="form-control-static"> {{partner.description}} </p>
                                            </div>
                                        </div>
                                    </div>
                                    <!--/span-->
                                    <div class="col-md-6">
                                        <div class="form-group row">
                                            <label class="control-label text-right col-md-3">Status:</label>
                                            <div class="col-md-9">
                                                <p class="form-control-static">
                                                    <span class="label label-inverse" v-if="partner.status === 'INACTIVE'">InActive</span>
                                                    <span class="label label-dark-green"
                                                          v-if="partner.status === 'ACTIVE'">Active</span>
                                                    <span class="label label-danger"
                                                          v-if="partner.status === 'SUSPENDED'">Suspended</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <!--/span-->
                                </div>
                                <!--/row-->
                                <h4 class="card-title">Address</h4>
                            </div>
                            <hr class="m-t-0 m-b-40">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group row">
                                            <label class="control-label text-right col-md-3">Address:</label>
                                            <div class="col-md-9">
                                                <p class="form-control-static"> {{partner.line1}},
                                                    {{partner.line2}} </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group row">
                                            <label class="control-label text-right col-md-3">City:</label>
                                            <div class="col-md-9">
                                                <p class="form-control-static"> {{partner.city}} </p>
                                            </div>
                                        </div>
                                    </div>
                                    <!--/span-->
                                    <div class="col-md-6">
                                        <div class="form-group row">
                                            <label class="control-label text-right col-md-3">State:</label>
                                            <div class="col-md-9">
                                                <p class="form-control-static"> {{partner.state}} </p>
                                            </div>
                                        </div>
                                    </div>
                                    <!--/span-->
                                </div>
                                <!--/row-->
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group row">
                                            <label class="control-label text-right col-md-3">Post Code:</label>
                                            <div class="col-md-9">
                                                <p class="form-control-static"> {{partner.postal_code}} </p>
                                            </div>
                                        </div>
                                    </div>
                                    <!--/span-->
                                    <div class="col-md-6">
                                        <div class="form-group row">
                                            <label class="control-label text-right col-md-3">Country:</label>
                                            <div class="col-md-9">
                                                <p class="form-control-static"> {{partner.country}} </p>
                                            </div>
                                        </div>
                                    </div>
                                    <!--/span-->
                                </div>
                            </div>
                            <hr>
                            <div class="form-actions" v-if="partner.status === 'INACTIVE'">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="row">
                                                <div class="col-md-offset-3 col-md-9">
                                                    <a @click="acceptInvitation" href="javascript:void(0)" class="btn btn-success" type="submit"><i
                                                            class="fa fa-pencil"></i> Approve
                                                    </a>
                                                    <a @click="rejectInvitation" href="javascript:void(0)" class="btn btn-danger ml-1" type="button">Reject</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "ParterIvitationRequest",
        props: ['memberid'],
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                partner: {
                    marketplace_name: '',
                    marketplace_id: null,
                    name: '',
                    description: '',
                    phone: '',
                    web: '',
                    email: '',
                    line1: '',
                    line2: '',
                    city: '',
                    state: '',
                    postal_code: '',
                    country: ''
                },
            }
        },
        mounted() {
            this.getPartnerInvitation();
        },
        methods: {
            async getPartnerInvitation() {
                try {
                    let {data} = await this.$http.get(`/org/partners/${this.memberid}`);
                    this.partner = data;
                } catch (e) {

                }
            },
            async acceptInvitation() {
                try {
                    await this.$http.post(`/marketplaces/${this.partner.marketplace_id}/members/${this.memberid}/active`);
                    this.$toastr('success', 'Invitation accepted', 'Accepted');
                    await this.$router.push({name: 'dashboard'});
                } catch (e) {

                }
            },
            async rejectInvitation() {
                try {
                    await this.$http.delete(`/marketplaces/${this.partner.marketplace_id}/members/${this.memberid}/removeOrg`);
                    this.$toastr('success', 'Invitation rejected', 'Rejected');
                    await this.$router.push({name: 'dashboard'});
                } catch (e) {

                }

            },
        }
    }
</script>

<style scoped>

</style>
